<template>
    <div class="loading-content-container">
        <div v-if="!loaded" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <b-row v-if="loaded">
            <csp-desktop-info-card
                :cols="12"
                icon="inticon-autoclaim_billing"
                title="Abrechnung">
                <div v-if="canOverrideFirmModalities" class="mb-4">
                    <b-form-checkbox v-model="overrideFirmModalities">
                        Firmengruppen-Modalitäten verwenden
                    </b-form-checkbox>
                </div>

                <div v-show="!overrideFirmModalities">
                    <h2>Rechtsanwalt / Schadendienstleister</h2>
                    <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                        no-rows-text="Es sind keine Rechtsanwälte oder Schadendienstleister zugewiesen."
                        :table-fields="serviceProviderModalityTableFields"
                        :table-form="serviceProviderForm"/>

                    <h2>Autohaus</h2>
                    <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                        :table-fields="carDealerModalityTableFields"
                        :table-form="carDealerForm"/>

                    <h2>Gutachter / Sachverständigenorganisation</h2>
                    <csp-invoicing-modality-table :invoice-recipient-options="invoiceRecipientOptions"
                        no-rows-text="Es sind keine Gutachter zugewiesen."
                        :table-fields="serviceProviderModalityTableFields"
                        :table-form="appraiserForm"/>
                </div>

                <csp-form-group-btn-submit @click="submit()"/>
            </csp-desktop-info-card>
        </b-row>
    </div>
</template>

<script>
    import InvoicingModalityTable from '@desktop/components/invoicingModality/InvoicingModalityTable.vue';
    import InvoicingModalityMixin from '@desktop/components/invoicingModality/InvoicingModalityMixin.vue';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const invoicingModalityRepository = container.getInvoicingModalityRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FirmInvoicingModalities',
        components: {
            'csp-invoicing-modality-table': InvoicingModalityTable,
        },
        mixins: [InvoicingModalityMixin],
        provide() {
            return {
                // define empty function to satisfy injection in InfoCard
                emitFieldChange: () => {},
            }
        },
        data() {
            const firmId = this.$route.params.firmId;

            return {
                firmId,
                canOverrideFirmModalities: false,
                overrideFirmModalities: false,
            }
        },
        mounted() {
            this.initializeForm();
        },
        methods: {
            handleSubmitSuccess() {
                flashMessenger.addSuccess('Die Abrechnungsmodalitäten wurden erfolgreich gespeichert.');

                // reset data attributes where necessary
                this.resetCommonData();
                this.canOverrideFirmModalities = false;
                this.overrideFirmModalities = false;

                // re-initialize form with fresh data
                this.initializeForm();
            },
            /** is called when the component is mounted and after every successful submit */
            initializeForm() {
                this.loaded = false;

                // load info that defines which and how many rows the modality tables have
                invoicingModalityRepository.showFirmStructure(this.firmId).then(
                    (data) => {
                        this.modalityStructure = data.data.attributes;
                        this.canOverrideFirmModalities = data.data.meta.canOverrideFirmModalities;

                        // load data of existing modality entries from database
                        invoicingModalityRepository.showFirmData(this.firmId).then(
                            (data) => {
                                this.modalityData = data.data;

                                if (!this.modalityData.length && this.canOverrideFirmModalities) {
                                    // if there are no existing modality data for the current firm,
                                    // then initialize the override checkbox as active
                                    this.overrideFirmModalities = true;
                                }

                                this.initializeTables();

                                // load options for invoice recipient select
                                invoicingModalityRepository.showFirmInvoiceRecipientOptions(this.firmId).then(
                                    (data) => {
                                        this.invoiceRecipientOptions = data.data.attributes;

                                        this.loaded = true;
                                    }
                                )
                            }
                        );
                    }
                );
            },
            submit() {
                this.modalityForm.clearValidationErrors();

                if (this.overrideFirmModalities) {
                    // delete all invoicing modality entries for the current firm to signal that the modalities
                    // of its firm group are to be used
                    invoicingModalityRepository.deleteFirmModalities(this.firmId).then(
                        () => {
                            this.handleSubmitSuccess();
                        }
                    );
                    return;
                }

                invoicingModalityRepository.updateFirm(this.firmId, this.prepareDataForSubmit()).then(
                    () => {
                        this.handleSubmitSuccess();
                    },
                    (error) => {
                        this.handleSubmitError(error);
                    }
                );
            },
        },
    }
</script>
